import React from 'react';
import { OrderResponseDto } from 'client/widget-components/ecom/types/EcomSDK';
import { OrderViewSection, OrderViewSectionTitle } from '../styles';
import DataCard, { DataRow } from '../components/DataCard';
import { UserCircle } from '../components/icons';
import {
    customFieldsToDataRows,
    getCustomFieldsByZone,
} from '../utils';
import { useEcommStr } from '../useEcommStr';

interface ContactSectionProps {
    order: OrderResponseDto;
}

const ContactSection: React.FC<ContactSectionProps> = ({ order }) => {
    const str = useEcommStr();
    const fieldsByZone = getCustomFieldsByZone(order);

    const rows: DataRow[] = [
        {
            key: 'email',
            label: str('nativeEcommRuntime.address_form.email'),
            value: order.email ?? undefined,
        },
        ...customFieldsToDataRows(fieldsByZone.CONTACT_INFO),
    ];

    return (
        <OrderViewSection>
            <OrderViewSectionTitle>
                {str('nativeEcommRuntime.contact_information.title')}
            </OrderViewSectionTitle>
            <DataCard
                rows={rows}
                dataAuto='order-contact-infos'
                icon={<UserCircle />}
            />
        </OrderViewSection>
    );
};

export default ContactSection;
